// extracted by mini-css-extract-plugin
export var columnList = "_bd-0";